import axios from "axios";
import { API_URL } from "../utils/constant";
import { SUBDOMAIN_FETCHED, SUBDOMAIN_FETCHED_SSL_TOTAL, APPLICATION_SECURITY_FETCHED, TECHNOLOGY, FETCH_VULNERABLE_SSL_GRAPH, FETCH_VULNERABLE_SSL, FETCH_VULNERABLE_SSL_TOTAL, SUBDOMAIN_FETCHED_SSL_GRAPH, SUBDOMAIN_FETCHED_SSL, FETCH_SUCCESS_DNS_DETAILS_GRAPH, FETCH_SUBDOMAIN_DETAIL, FETCH_SUCCESS_DNS_DETAILS_TOTAL, SUBDOMAIN_FETCHED_TOTAL, SUBDOMAIN_FETCHED_GRAPH, SUBDOMAIN_SCAN_STARTED, LOOK_ALIKE_FETCHED, INVENTORY_DETAILS_FETCHEDV1, FETCH_DNS_DETAILS, FETCH_SUCCESS_DNS_DETAILS, SECURITY_HEADER } from "./index";
import { toastr } from "react-redux-toastr";
import { data } from "jquery";
// import { toastr } from 'react-redux-toastr';

export const fetchSubDomains = (props, dispatch, page, category, domain_search_query, status, startDate, endDate, limit, domain_filter = "all") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/expired-ssl-certificates/${props}/delta?page=${page}&limit=${limit}&category=${category}&domain_search_query=${domain_search_query}&status=${status}&from=${startDate}&till=${endDate}&domain=${domain_filter}`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_SSL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_SSL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomainsAction = (props, dispatch, page, category, domain_search_query, status, data,domain) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/expired-ssl-certificates/${props}/action?page=${page}&category=${category}&domain_search_query=${domain_search_query}&status=${status}&domain=${domain}`, data)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_SSL,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Success", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_SSL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomainsTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/expired-ssl-certificates/${props}/totals`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchSubDomainsGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/expired-ssl-certificates/${props}/graph`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_SSL_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchVulnerableSsl = (props, dispatch, page, category, domain_search_query, status, limit) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/vulnerable-ssl/${props}/delta?page=${page}&limit=${limit}&category=${category}&domain_search_query=${domain_search_query}&status=${status}`)
      .then((response) => {
        dispatch({
          type: FETCH_VULNERABLE_SSL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_VULNERABLE_SSL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchVulnerableSslAction = (props, dispatch, page, category, domain_search_query, status, data) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/vulnerable-ssl/${props}/action?page=${page}&category=${category}&domain_search_query=${domain_search_query}&status=${status}`, data)
      .then((response) => {
        dispatch({
          type: FETCH_VULNERABLE_SSL,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_VULNERABLE_SSL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchVulnerableTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/vulnerable-ssl/${props}/totals`)
      .then((response) => {
        dispatch({
          type: FETCH_VULNERABLE_SSL_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_VULNERABLE_SSL_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchVulnerableGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/vulnerable-ssl/${props}/graph`)
      .then((response) => {
        dispatch({
          type: FETCH_VULNERABLE_SSL_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_VULNERABLE_SSL_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchWebTech = (props, page, dispatch, category, filterData, searchBy, searchValue, minExploitabilityScore, severity, startDate, endDate, limit, domain = "") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/webtech_analysis/${props}/delta?pageno=${page}&limit=${limit}&category=${category}&searchBy=${searchBy}&q=${searchValue}&type=${filterData}&minExploitabilityScore=${minExploitabilityScore}&severity=${severity}&from=${startDate}&till=${endDate}&domain=${domain}`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const technology = (props, page, dispatch, searchBy, order) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/outdated-technology/list?page=${page}&limit=10&search=${searchBy}&sortOrder=${order}`)
      .then((response) => {
        dispatch({
          type: TECHNOLOGY,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: TECHNOLOGY,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const technologyEdit = (props, dispatch, data, page) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .patch(`${API_URL}/outdated-technology/${props}`, data)
      .then((response) => {
        dispatch({
          type: TECHNOLOGY,
          payload: response.data,
        });
        if (response.data.status == 200) {
          technology(props, page, dispatch, '')
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: TECHNOLOGY,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const technologyCreate = (props, dispatch, data) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .post(`${API_URL}/outdated-technology`, data)
      .then((response) => {
        dispatch({
          type: TECHNOLOGY,
          payload: response.data,
        });
        if (response.data.status == 200) {
          technology(props, 1, dispatch, '')
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: TECHNOLOGY,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const technologyDelete = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .delete(`${API_URL}/outdated-technology/${props}/delete`)
      .then((response) => {
        dispatch({
          type: TECHNOLOGY,
          payload: response.data,
        });
        if (response.data.status == 200) {
          technology(props, 1, dispatch, '')
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        dispatch({
          type: TECHNOLOGY,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchWebTechAction = (props, page, dispatch, category, filterData, searchBy, searchValue, data, domain = "") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/webtech_analysis/${props}/action?pageno=${page}&category=${category}&searchBy=${searchBy}&q=${searchValue}&type=${filterData}&domain=${domain}`, data)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.success("Error", response.data.userMessage);
        }
      })
  }
};

export const fetchWebTechGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/webtech_analysis/${props}/graph`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchWebTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/webtech_analysis/${props}/totals`)
      .then((response) => {
        dispatch({
          type: SUBDOMAIN_FETCHED_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SUBDOMAIN_FETCHED_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const addSubDmoan = (props, dispatch) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .post(`${API_URL}/createSubDomain`, { ...props })
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
          return false;
        } else {
          toastr.success("Success", response.data.userMessage);
        }
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        toastr.error("Error", message);
        dispatch({
          type: SUBDOMAIN_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const startScanSubdomain = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/start-scan/${props.subdomain}`)
      .then((response) => {
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
        } else {
          toastr.success("Success", response.data.userMessage);
        }
        dispatch({
          type: SUBDOMAIN_SCAN_STARTED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
        toastr.error("Error", message);
        dispatch({
          type: SUBDOMAIN_SCAN_STARTED,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const getSubDetails = (props, dispatch) => {
  if (props !== undefined) {
    axios.get(`${API_URL}/dns-details/${props}`).then((res) => {
      if (res.data.error) {
        toastr.error("ERROR", "Something went wrong");
      } else {
        toastr.success("SUCCESS", "Data Fetched.");
      }
      dispatch({
        type: FETCH_SUBDOMAIN_DETAIL,
        subDomainDetail: res.data,
      });
    });
  }
};

export const subDomainScan = (props, dispatch) => {
  if (props !== undefined) {
    // const cookie = new Cookies();
    // const session = cookie.get("session");
    const session = localStorage.getItem("session");
    axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
    axios.post(`${API_URL}/start-scan`, props).then((res) => {
      if (res.data.error) {
        toastr.error("ERROR", res.data.userMessage);
        return false;
      } else {
        toastr.success("SUCCESS", "Scan started.");
      }
      if (props.isVulnerabilities) {
        dispatch({
          type: INVENTORY_DETAILS_FETCHEDV1,
          data: res.data.data,
        });
      } else {
        dispatch({
          type: LOOK_ALIKE_FETCHED,
          payload: res.data,
        });
      }
    });
  }
}

export const getDnsDetails = (props, flag, dispatch, page, limit, search, filterData, category, recordType = "all", type = "all") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getDnsDetails/${props}?filter=${flag}&page=${page}&limit=${limit}&search=${search || filterData}&category=${category}&recordType=${recordType}&type=${type}`)
      .then((response) => {
        dispatch({
          type: FETCH_DNS_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const getDnsDetailsAction = (props, flag, dispatch, page, limit, search, filterData, category, data, recordType = "all", type = "all") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/getDnsDetails/${props}/action?filter=${flag}&page=${page}&limit=${limit}&search=${search || filterData}&category=${category}&recordType=${recordType}&type=${type}`, data)
      .then((response) => {
        dispatch({
          type: FETCH_DNS_DETAILS,
          payload: response.data,
        });
        if (response.data.error) {
          toastr.error("Error", response.data.userMessage);
          return false;
        } else {
          toastr.success("Success", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const addSubdomains = (props, data) => {
  const session = localStorage.getItem("session");
  axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;

  if (props) {
    axios
      .post(`${API_URL}/${props}/queue/subdomain/add`, data)
      .then((response) => {
        if (response.data.error == false) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }
      });
  }
};


export const getSubDomainDetails = (props, dispatch, page, category, status, domainquery, domain, startDate, endDate, limit) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSubDomainDetails/${props}/delta?page=${page}&limit=${limit}&category=${category}&status=${status}&domainquery=${domainquery}&domain=${domain}&from=${startDate}&till=${endDate}`)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const getSubDomainDetailsAction = (props, dispatch, page, category, status, domainquery, domain, data) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/getSubDomainDetails/${props}/action?page=${page}&category=${category}&status=${status}&domainquery=${domainquery}&domain=${domain}`, data)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: response.data,
        });
        if (response.data.status == 200) {
          toastr.success("Success", response.data.userMessage);
        } else {
          toastr.error("Error", response.data.userMessage);
        }
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const getSubDomainDetailsTotal = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSubDomainDetails/${props}/totals`)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_TOTAL,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_TOTAL,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const getSubDomainDetailsGraph = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSubDomainDetails/${props}/graph`)
      .then((response) => {
        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_GRAPH,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: FETCH_SUCCESS_DNS_DETAILS_GRAPH,
          payload: { error: true, userMessage: message },
        });
      });
  }
}

export const fetchSecurityHeader = (props, dispatch) => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .get(`${API_URL}/getSecurityHeader/${props}`)
      .then((response) => {
        dispatch({
          type: SECURITY_HEADER,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: SECURITY_HEADER,
          payload: { error: true, userMessage: message },
        });
      });
  }
};


export const fetchApplicationSecurity = (props, page, dispatch, limit, category, domain = "", severity = "") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      .get(`${API_URL}/domain-vulnerabilities/${props}?page=${page}&limit=${limit}&category=${category}&domain=${domain}&severity=${severity}`)
      .then((response) => {
        dispatch({
          type: APPLICATION_SECURITY_FETCHED,
          payload: response.data,
        });
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: APPLICATION_SECURITY_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};

export const fetchApplicationSecurityAction = (props, page, dispatch, limit, category, data, domain = "", severity = "") => {
  // const cookie = new Cookies();
  // const session = cookie.get("session");
  const session = localStorage.getItem("session");
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${session}`;
  if (props === undefined) {
    return null;
  } else {
    axios
      // .get(`${API_URL}/domainsquatting?domain=${props}`)
      .post(`${API_URL}/domain-vulnerabilities/${props}/action?page=${page}&limit=${limit}&category=${category}&domain=${domain}&severity=${severity}`, data)
      .then((response) => {
        fetchApplicationSecurity(props, page, dispatch, limit, category, domain, severity)
        toastr.success("Success", response.data.userMessage);
      })
      .catch((err) => {
        var message = "Some server error has occurred.";
        if (err.response) {
          message = err.response.data.userMessage;
        }

        dispatch({
          type: APPLICATION_SECURITY_FETCHED,
          payload: { error: true, userMessage: message },
        });
      });
  }
};